import { FlattenedPlanData } from "../../hooks/useWellnessPlans";

export const actionTypes = {
  SET_WELLNESS_PURCHASE_DATA: "SET_WELLNESS_PURCHASE_DATA",
};

const setWellnessPurchaseData = (payload: FlattenedPlanData | null) => ({
  type: actionTypes.SET_WELLNESS_PURCHASE_DATA,
  payload,
});


export default {
  setWellnessPurchaseData,
};
